// src/hooks/useSite.ts
import { useState, useEffect } from 'react';
import { message } from 'antd';
import { siteApi, SiteConfig } from '@/services/api/site';

export const useSite = () => {
  const [siteConfig, setSiteConfig] = useState<SiteConfig | null>(null);
  const [loading, setLoading] = useState(false);

  // Загрузка настроек сайта
  const loadSiteConfig = async () => {
    setLoading(true);
    try {
      const response = await siteApi.getConfig();
      setSiteConfig(response.data.data);
    } catch (error: any) {
      console.error('Error loading site config:', error);
      message.error('Ошибка загрузки настроек сайта');
      // Fallback значения - устанавливаем null вместо неполного объекта
      setSiteConfig(null);
    } finally {
      setLoading(false);
    }
  };

  // Загрузка при монтировании
  useEffect(() => {
    loadSiteConfig();
  }, []);

  return {
    siteConfig,
    loading,
    loadSiteConfig,
  };
};